module.exports = __webpack_public_path__ + "static/media/Gor 2018.11.03psd.4361d479.webp";